export const SOLE_TRADER_PHONE_NUMBER = '01233 653971';
export const DEFAULT_PHONE_NUMBER = '01233 628648';
export function phoneNumber(soleTrader) { return soleTrader ? SOLE_TRADER_PHONE_NUMBER : DEFAULT_PHONE_NUMBER; }
